/* jshint node:true */
'use strict';

var React = require('react');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');
var VisPercent = require('./VisPercent.jsx');
var StatsTable = require('./StatsTable.jsx');
var utils = require('../../../helpers/utils/index.js');

var MatchStats = React.createClass({

    displayName: 'MatchStats',
    
    viewAll: function(oEvent){
        if(this.props.changeView){
            this.props.changeView('matchstats');
        }
    },
    
    render: function () {
        
        var stats = this.props.stats;
        var possession = this.props.possession;
        var territory = this.props.territory;
        var homeLogo = utils.getImageUrl(this.props.home.logo);
        var awayLogo = utils.getImageUrl(this.props.away.logo);
        var homeAbbrev = this.props.home.abbreviation;
        var awayAbbrev = this.props.away.abbreviation;
        var statsView = null;

        return (
            <div className="sub-module match-stats soccer">
                <header className="bordered">
                    <h1>Match Stats</h1>
                </header>
                <div className="content" style={{overflow:'auto'}}>
                    <div className="data-vis">
                        <TeamCompareHeader heading="possession" home={{abbreviation: homeAbbrev, logo:homeLogo}} away={{abbreviation: awayAbbrev, logo: awayLogo}} />
                        <VisPercent percent={possession} colors={[this.props.home.color, this.props.away.color]} />
                        <TeamCompareHeader heading="territory" noTeams={'no-teams'} home={{abbreviation: homeAbbrev, logo:homeLogo}} away={{abbreviation: awayAbbrev, logo: awayLogo}} />
                        <VisPercent percent={territory} large={true} colors={[this.props.home.color, this.props.away.color]} />
                    </div>
                    <div className="stat-list">
                        <TeamCompareHeader bordered='bordered' home={{abbreviation: homeAbbrev, logo:homeLogo}} away={{abbreviation: awayAbbrev, logo: awayLogo}} />
                        <StatsTable stats={stats} />
                    </div>
                </div>
                <footer>
                    <a onClick={this.viewAll}>Full Match Stats</a>
                </footer>
            </div>
        );
    }
});

module.exports = MatchStats;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/MatchStats.jsx
 **/